import React from "react";
import WorksListItem from "../WorksListItem";
import {
  Wrapper,
  WorksTitle,
  ButtonsWrapper,
  FilterButton,
  NDAWrapper,
  StyledDivider,
  StyledEmailMe
} from "./style";

const WorksListSection = ({ works, category, setCategory }) => (
  <Wrapper>
    <header>
      <WorksTitle>Events</WorksTitle>
      <ButtonsWrapper>
        <FilterButton
          active={category === "future"}
          onClick={() => setCategory("future")}
        >
          future
        </FilterButton>
        <FilterButton
          active={category === "past"}
          onClick={() => setCategory("past")}
        >
          past
        </FilterButton>
        {category && (
          <FilterButton onClick={() => setCategory(null)}>all</FilterButton>
        )}
      </ButtonsWrapper>
    </header>
    <main>
      {works.map(({ work }, i) => (
        <WorksListItem key={i} work={work} />
      ))}
    </main>
  </Wrapper>
);

export default WorksListSection;



// WEBPACK FOOTER //
// ./src/components/WorksListSection/index.js